'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.log = log;
exports.warn = warn;
function log() {

    if (process.env.NODE_ENV === 'development') {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        console.log(args);
    }
}

function warn() {

    if (process.env.NODE_ENV === 'development') {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        console.warn(args);
    }
}


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/arreeba-form/lib/lib/logging.js
// module id = 78
// module chunks = 0